import _ from 'underscore';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { siteMapPropType } from '@bingads-webui-campaign-react/with-site-map';
import { StyledSubPageMenu } from '@bingads-webui-campaign-react/sub-page-menu';
import { Activity, Scenario } from '@bingads-webui-react/hoc-with-signal';

export const Loader = (props) => {
  const { siteMap, updateAvailability } = props;

  const selectedParent = _.findWhere(siteMap, { selected: true });
  const available = !_.isEmpty(selectedParent);
  useEffect(() => {
    updateAvailability(available);
  });

  return props.isVisible ? (
    <Scenario name="sub-page-memu">
      <Activity name="default-sub-page-memu">
        <StyledSubPageMenu {...props} selectedParent={selectedParent && selectedParent.id} />
      </Activity>
    </Scenario>
  ) : null;
};

Loader.propTypes = {
  siteMap: siteMapPropType.isRequired,
  updateAvailability: PropTypes.func,
  isVisible: PropTypes.bool.isRequired,
  changeLayout: PropTypes.func.isRequired,
};

Loader.defaultProps = {
  updateAvailability: _.noop,
};

export const DefaultSubPageMenuLoader = React.memo(Loader);
